import React from 'react';
import ReactDOM from "react-dom";
import { observer } from 'mobx-react';
import get from 'lodash/get';
import loadable from '@loadable/component';
import pageStore from 'stores/ReperksWidget/PageStore';
import activitiesPageStore from 'stores/ReperksWidget/ActivitiesPageStore';
import * as widgetUtils from 'stores/ReperksWidget/Utils';
import constants from 'Constants';
import * as api from 'Api';
import * as utils from 'Utils';
import apiReady from './ready';
import 'styles/main.scss';


const ReperksWidget = loadable(() => import('containers/ReperksWidget'));


// Note:
// Can't use `utils.isProduction()` to check production mode. If you use that samples
// will always get included into assets for some unknown reasons.
let samples = {};
if (process.env.NODE_ENV !== 'production') {
  samples = require('./samples').default;
}


@observer
class App extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.start();

    const platform = utils.getEcommercePlatform();

    if (platform === 'wix') {
      document.addEventListener('ov_wix_login_success', this.onWixLoginSuccess);
      document.addEventListener('ov_wix_signup_success', this.onWixSignupSuccess);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('ov_wix_login_success', this.onWixLoginSuccess);
    document.removeEventListener('ov_wix_signup_success', this.onWixSignupSuccess);
  }

  onWixLoginSuccess = (evt) => {
    this.loadReperksWidget();
  };

  onWixSignupSuccess = (evt) => {
    this.loadReperksWidget();
  };

  deserializePreview = async () => {
    await pageStore.deserialize(window.OV_PREVIEW_DATA);
    await activitiesPageStore.deserialize(window.OV_PREVIEW_DATA.activities);
  };

  start = async () => {
    if (!window.OnVoardReperks) window.OnVoardReperks = {};
    await this.setupPreview();
    await this.loadReperksWidget();
  };

  setupPreview = async () => {
    if (!utils.isPreview()) return;

    if (!window.OV_PREVIEW_DATA) window.OV_PREVIEW_DATA = {};
    window.ovReloadPreview = async () => {
      const el = document.querySelector(".ov-app-reperks-widget");
      if (!el) return;

      await this.deserializePreview();
      pageStore.setEl(el);
      widgetUtils.loadReperksWidgetCustomStyles(pageStore);
    };

    window.ovUpdateConfig = (field, value) => {
      const widgetConfig = pageStore.widgetConfig;
      widgetConfig.setFieldValue(field, value);
    };

    window.ovUpdateLauncher = (field, value) => {
      const launcher = pageStore.widgetConfig.launcher;
      launcher.setFieldValue(field, value);
    };

    window.ovUpdateLauncherExtended = (field, value) => {
      const extended = pageStore.widgetConfig.launcher.extended;
      extended.setFieldValue(field, value);
    };

    window.ovUpdateLauncherMinimal = (field, value) => {
      const minimal = pageStore.widgetConfig.launcher.minimal;
      minimal.setFieldValue(field, value);
    };

    window.ovUpdateTheme = (field, value) => {
      const theme = pageStore.widgetConfig.theme;
      theme.setFieldValue(field, value);
    };

    window.ovUpdateTranslation = (field, value) => {
      const translation = pageStore.widgetConfig.translation;
      translation.setFieldValue(field, value);
    };

    window.ovSwitchLauncher = () => {
      pageStore.switchLauncher();
    };

    window.ovSwitchPanel = () => {
      pageStore.switchPanel();
    };
  };

  embedInlineWidget = () => {
    const component = <ReperksWidget />;
    ReactDOM.render(<div className="ov-wrapper">{component}</div>, pageStore.el);
  };

  loadReperksWidget = async () => {
    const ovData = window.OnVoardData;
    const platform = utils.getEcommercePlatform();
    const el = document.querySelector(".ov-app-reperks-widget");

    let appId = el.getAttribute('data-app-id');
    if (!appId && platform === 'shopline') {
      if (ovData && ovData.config) {
        appId = ovData.config['reperks_id'];
      }
    }

    if (appId && !el.getAttribute('data-app-id')) {
      el.setAttribute("data-app-id", appId);
    }

    if (!appId) return;

    // init widget
    const widgetConfig = pageStore.widgetConfig;
    pageStore.setId(appId);
    pageStore.setEl(el);

    const memberExternalId = utils.extractMemberExternalId();
    if (memberExternalId) pageStore.setMemberExternalId(memberExternalId);

    if (!utils.isProduction()) {
      await pageStore.deserialize(samples.s2);
      apiReady(this);

      widgetUtils.onReadyWidget(pageStore);
      widgetUtils.loadReperksWidgetCustomStyles(pageStore);
      this.embedInlineWidget();
      return;
    }

    if (utils.isPreview()) {
      await this.deserializePreview();
      apiReady(this);

      widgetUtils.onReadyWidget(pageStore);
      widgetUtils.loadReperksWidgetCustomStyles(pageStore);
      this.embedInlineWidget();
      return;
    }

    const successCallback = async (response) => {
      await pageStore.deserialize(response);
      apiReady(this);

      const successTasks = () => {
        widgetUtils.onReadyWidget(pageStore);
        widgetUtils.loadReperksWidgetCustomStyles(pageStore);
        this.embedInlineWidget();
      };

      successTasks();
      if (pageStore.onReadyCallback) {
        try {
          pageStore.onReadyCallback();
        } catch (error) {
          console.error(error);
        }
      }
    };

    const errorCallback = (errors) => {
      utils.printErrors(errors);
    };

    const params = pageStore.params;
    api.getReperksWidgetPayloads(successCallback, errorCallback, pageStore.id, params);
  };

  render() {
    return (
      <div>
        <div dangerouslySetInnerHTML={{__html: require('../static/icons/box-icon.svg').default}} />
        <div dangerouslySetInnerHTML={{__html: require('../static/icons/bp-icon.svg').default}} />
        <div dangerouslySetInnerHTML={{__html: require('../static/icons/fa-icon.svg').default}} />
      </div>
    )
  }
}



export default App;
